import BaseService from "@/shared/base.service";
import { ExecutionParams } from "@/types/request/getExecution";

import type { ExecutionResponse } from "@/types/response/execution";

export class ExecutionService {
  static async GetExecutions(payload: ExecutionParams
  ): Promise<ExecutionResponse | null> {
    try {
      const params = { ...payload };

      const queryParams = Object.fromEntries(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        Object.entries(params).filter(([_, v]) => v != null)
      );

      const response = await BaseService.get<ExecutionResponse>(
        `executions`,
        queryParams
      );

      return response ?? null;
    } catch (error) {
      console.error("Error in GetExecutions:", error);
      return null;
    }
  }
}
